import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-password-toggle',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './password-toggle.component.html',
  styleUrls: ['./password-toggle.component.scss']
})
export class PasswordToggleComponent {
  @Input({ required: true }) for!: string;

  isVisible = false;

  private resolveInput(): HTMLInputElement | null {
    if (!this.for) {
      console.error('For attribute is required');
      return null;
    }

    const input = document.getElementById(this.for) as HTMLInputElement;

    if (!input) {
      console.error('Input element not found, make sure input ID matches the for attribute');
      return null;
    }

    return input as HTMLInputElement;
  }

  toggleVisibility(): void {
    const inputEl = this.resolveInput();

    if (!inputEl) {
      return;
    }

    this.isVisible = !this.isVisible;

    inputEl.type = this.isVisible ? 'text' : 'password';
  }
}
